import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import io from 'socket.io-client';

// Components
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import TradingInterface from './components/TradingInterface';
import Leaderboard from './components/Leaderboard';
import Profile from './components/Profile';
import BettingRooms from './components/BettingRooms';
import Demo from './components/Demo';
import BetDetails from './components/BetDetails';
import ErrorBoundary from './components/ErrorBoundary';

// Context
import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import { MarketDataProvider } from './context/MarketDataContext';

// Styles
import './App.css';

function App() {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Initialize socket connection
    const newSocket = io('/', {
      autoConnect: false
    });

    setSocket(newSocket);

    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="App min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900">
        <AuthProvider>
          <SocketProvider socket={socket}>
            <MarketDataProvider>
              <Router>
                <div className="min-h-screen">
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/demo" element={<Demo />} />
                    <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                    <Route path="/trade" element={<ProtectedRoute><TradingInterface /></ProtectedRoute>} />
                    <Route path="/bet/:id" element={<ProtectedRoute><BetDetails /></ProtectedRoute>} />
                    <Route path="/leaderboard" element={<ProtectedRoute><Leaderboard /></ProtectedRoute>} />
                    <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                    <Route path="/rooms" element={<ProtectedRoute><BettingRooms /></ProtectedRoute>} />
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                </div>
                <Toaster 
                  position="top-right"
                  toastOptions={{
                    duration: 4000,
                    style: {
                      background: '#1f2937',
                      color: '#f3f4f6',
                      border: '1px solid #374151'
                    }
                  }}
                />
              </Router>
            </MarketDataProvider>
          </SocketProvider>
        </AuthProvider>
      </div>
    </ErrorBoundary>
  );
}

// Protected Route Component
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900 flex items-center justify-center">
        <div className="casino-card p-8 text-center">
          <div className="spinner mx-auto mb-4"></div>
          <p className="text-white">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

export default App;